import React, { ReactNode } from 'react';

import classes from './OptionWithDescription.module.scss';

type OptionWithDescriptionProps = {
  label: ReactNode;
  description?: ReactNode;
};

const OptionWithDescription = ({ label, description }: OptionWithDescriptionProps) => {
  return (
    <div className={classes.box}>
      <span>{label}</span>
      {description && <span className={classes.description}>{description}</span>}
    </div>
  );
};

export { OptionWithDescription };
